<template>
  <div :class="['timeline_item', {'last': last}]">
    <div class="timeline_item--line">
      <div :class="['timeline_item--dot', color, {'with_icon': icon}, {'outlined': outlined}]">
        <icon-default
          v-if="icon"
          :icon="icon"
          size="is-small"
        ></icon-default>
      </div>
    </div>

    <div class="timeline_item--main">
      <h3 class="timeline_item--main--title">
        <span :class="['timeline_item--dot', color, {'with_icon': icon}, {'outlined': outlined}]">
          <icon-default
            v-if="icon"
            :icon="icon"
            size="is-small"
          ></icon-default>
        </span>
        <strong>{{ type }}</strong>
        <sensitive-data-wrapper>
          <span v-if="title">: {{ title }}</span>
        </sensitive-data-wrapper>
      </h3>

      <div class="timeline_item--main--subtitle">
        <p>{{ date }}</p>
        <p v-if="byName">by {{ byName }}</p>
        <slot name="subtext"></slot>
      </div>

      <div class="timeline_item--main--slot">
        <slot></slot>
      </div>
    </div>

    <div class="timeline_item--column">
      <slot name="column"></slot>
    </div>
  </div>
</template>

<script>
import SensitiveDataWrapper from "../../../components/SensitiveDataWrapper.vue";

export default {
  name: "CommunicationItem",
  components: {SensitiveDataWrapper},
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
    date: {
      type: String,
      required: true
    },
    byName: {
      type: String,
    },
    icon: {
      type: String,
    },
    color: {
      type: String,
    },
    outlined: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

$smallDotDiameter: 24px;
$largeDotDiameter: 36px;
$lineWidth: 60px;

.timeline_item {
  position: relative;
  display: flex;
  padding: 8px 0 20px; // this is to account for the after line

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: calc($lineWidth/2);
    width: 2px;
    margin-left: -1px;
    background-color: $border;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 6px;
    left: calc($lineWidth/2);
    right: 0;
    height: 1px;
    background-color: $border;
  }

  &.last {

    &::before {
      bottom: 50%;
    }

    &::after {
      content: none;
    }
  }

  &--dot {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    height: $smallDotDiameter;
    width: $smallDotDiameter;
    background-color: $light-grey;
    border: 2px solid $light-grey;
    border-radius: 50%;
    color: $white;

    &.is-primary {
      background-color: $primary;
      border-color: $primary;
    }

    &.is-secondary {
      background-color: $secondary;
      border-color: $secondary;
    }

    &.is-grey {
      background-color: lighten($dark-grey, 20%);
      border-color: lighten($dark-grey, 20%);
    }

    &.is-notes {
      background-color: $notes;
      border-color: $notes;
    }

    &.is-calls {
      background-color: $calls;
      border-color: $calls;
    }

    &.is-texts {
      background-color: $texts;
      border-color: $texts;
    }

    &.is-emails {
      background-color: $emails;
      border-color: $emails;
    }

    &.is-activities {
      background-color: $activities;
      border-color: $activities;
    }

    &.with_icon {
      height: $largeDotDiameter;
      width: $largeDotDiameter;
    }

    &.outlined {
      background-color: $white;
      color: $dark-grey;

      &.is-primary {
        color: $primary;
      }

      &.is-secondary {
        color: $secondary;
      }

      &.is-grey {
        color: $light-grey;
      }

      &.is-notes {
        color: $notes;
      }

      &.is-calls {
        color: $calls;
      }

      &.is-texts {
        color: $texts;
      }

      &.is-emails {
        color: $emails;
      }

      &.is-activities {
        color: $activities;
      }
    }
  }

  &--line {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 $lineWidth;
  }

  &--main {
    flex: 0 0 440px;

    &--title {
      margin-bottom: 6px;
    }

    .timeline_item--dot {
      display: none;
    }

    &--subtitle {
      color: $text-muted;
      font-size: 0.875em;

      p {
        margin-bottom: 4px;
      }
    }

    &--slot {
      margin-top: 8px;
    }
  }

  &--column {
    flex-grow: 0;
    padding: 0 1rem;
  }

  @include mobile {
    flex-wrap: wrap;
    margin-bottom: 12px;
    padding: 8px 0;
    background-color: $white;

    &::before,
    &::after {
      content: none;
    }

    &--line {
      display: none;

      .timeline_item--dot {
        display: none;
      }
    }

    &--main {
      flex: 0 0 100%;
      padding: 8px;

      .timeline_item--dot {
        display: inline-flex;

        &.with_icon {
          height: $smallDotDiameter;
          width: $smallDotDiameter;
        }
      }
    }

    &--column {
      flex: 0 0 100%;
      padding: 8px 8px 0;
      border-top: 1px solid $border;
    }
  }
}
</style>
